import { Link } from '@tanstack/react-router';

export type BreadcrumbProps = {
  items?: { name: string; url?: string }[];
};
export const Breadcrumb = ({ items }: BreadcrumbProps) => {
  if (!items) {
    return null;
  }
  return (
    <nav aria-label="breadcrumb" className="bq-breadcrumb">
      <ol>
        <li key={-1} className="breadcrumb-item">
          <Link to={'/'} className="text-sm" activeOptions={{ exact: true }}>
            {/*<i className="pi pi-home"/>*/}

            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="20px"
              viewBox="0 -960 960 960"
              width="24px"
              fill="#5f6368"
            >
              <path d="M180-120q-25 0-42.5-17.5T120-180v-76l160-142v278H180Zm140 0v-160h320v160H320Zm360 0v-328L509-600l121-107 190 169q10 9 15 20.5t5 24.5v313q0 25-17.5 42.5T780-120H680ZM120-310v-183q0-13 5-25t15-20l300-266q8-8 18.5-11.5T480-819q11 0 21.5 3.5T520-804l80 71-480 423Z" />
            </svg>
          </Link>
        </li>
        {items.map((item, index) => {
          if (index === items.length - 1) {
            return (
              <li
                key={index}
                className="breadcrumb-item active"
                aria-current="page"
              >
                <span className="last-item"> {item.name} </span>
              </li>
            );
          } else {
            return (
              <li key={index} className="breadcrumb-item">
                <Link
                  to={item.url}
                  className="text-sm"
                  activeOptions={{ exact: true }}
                >
                  {item.name}
                </Link>
              </li>
            );
          }
        })}
      </ol>
    </nav>
  );
};
